import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'shared-shimmer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shimmer.component.html',
  styleUrl: './shimmer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('fadeOutOnLeave', [transition(':leave', [animate('200ms ease', style({ opacity: 0 }))])])],
  host: {
    '[@fadeOutOnLeave]': '', // run the leave animation when this component is removed
  },
})
export class ShimmerComponent {
  @Input()
  public width = '80%';

  @Input()
  public height = '12px';

  @Input()
  public shape: 'circle' | 'square' | 'rect' = 'rect';

  @Input()
  public borderRadius = '5px';

  protected get shimmerHeight(): string {
    switch (this.shape) {
      case 'circle':
      case 'square':
        return this.width;

      default:
        return this.height;
    }
  }

  protected get shimmerBorderRadius(): string {
    return this.shape === 'circle' ? '50%' : this.borderRadius;
  }
}
